{
	"title": "Atributele CO\u2082 captat",
	"buttonTitle": "Captarea și stocarea carbonului",
	"table": {
		"materialDescription": "Material",
		"quantity": "Cantitate",
		"productGwpTotal": "GWP total produs",
		"bundledCarbonReductions": "Reduceri de CO\u2082 incluse",
		"remainingGwp": "GWP rămas",
		"epdForPhysicalMaterial": "EPD pentru material fizic",
		"carbonPlantName": "Brevik, Norvegia"
	},
	"declarationDetailsBanner": {
		"rightfulHolderText": "este deținătorul de drept al reducerilor de CO\u2082 raportate."
	},
	"modal": {
		"title": "Captarea și stocarea carbonului",
		"description": "Captarea și stocarea carbonului (CCS) este o tehnologie care poate capta emisiile de dioxid de carbon (CO\u2082) produse în urma procesului de calcinare și a utilizării combustibililor în funcționarea cuptorului, împiedicând dioxidul de carbon să ajungă în atmosferă și stocându-l permanent în subteran. CO\u2082 captat de la fabrica Heidelberg Materials din Brevik, Norvegia, este comprimat și transportat către un sit de stocare de sub Marea Nordului. Instalația de la fabrica noastră din Brevik va capta anual 400.000 de tone de CO\u2082.",
		"showLink": "Află mai multe despre procesul de captare a carbonului",
		"buttonClose": "Închide"
	},
	"footnote": "1) Reducerile de CO\u2082 compensează etapele A1-A3 ale inventarului ciclului de viață al cimentului."
}
